// Module
var code = "<div class=\"hero-unit-quality\"><div class=\"hero-global\"><img alt=\"hero image\" class=\"hero-image\" src=\"https://images.emersonecologics.com/Webcontent/AresHomePageSlideShow/girl_veggie_basket_1400x690.jpg\"></div><h1>Raising the Standard on Quality</h1></div><div ui-view autoscroll=\"true\"></div>";
// Exports
module.exports = code;